import React, { Fragment, useState, useEffect, useRef, useLayoutEffect } from "react";
import { Input, DropDown } from './Forms';
import { useApi } from '../../services/api';
import $ from 'jquery';
import 'bootstrap/js/dist/modal';

function Modal({ title, children, buttons, setShowModal }){

	const element = useRef(null);

	useLayoutEffect( () => {
		$(element.current).modal();
		
		if(setShowModal){
			$(element.current).on('hidden.bs.modal', (event) => {
				setShowModal(false);
			});
		}

		return () => {
			$(element.current).modal('dispose');
		}
	}, []);

	return (<div ref={element} className="modal fade" tabIndex="-1" role="dialog">
		<div className="modal-dialog modal-dialog-centered" role="document">
			<div className="modal-content">
				<div className="modal-header text-center">
					<h5 className="modal-title mx-auto w-100 font-weight-bolder">{title}</h5>
					<button type="button" className="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div className="modal-body text-justify">
					{children}
				</div>
				
				{buttons && <div className="modal-footer">{buttons}</div>}
			</div>
		</div>
	</div>);
}

export default Modal;